import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	for (const element of document.querySelectorAll(".excluded-by-region")) {
		element.remove();
	}
	$('.industry-carousel .industries').slick({
		arrows: true,
		autoplay: false,
		autoplaySpeed: 10000,
		centerMode: false,
		centerPadding: 0,
		cssEase: 'linear',
		dots: false,
		draggable: true,
		fade: false,
		infinite: true,
		pauseOnHover: false,
		slidesToShow: 5,
		variableWidth: false,
		slidesToScroll: 1,
		speed: 500,
		responsive: [
			{
				breakpoint: 1300,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
})
